<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()">
      <img src="/assets/images/samedtech.png" width="50px" />Onboarding
      <span style="font-size: small"></span
    ></a>
  </div>
  <!-- <nb-select
    [selected]="currentTheme"
    (selectedChange)="changeTheme($event)"
    status="primary"
  >
    <nb-option *ngFor="let theme of themes" [value]="theme.value">
      {{ theme.name }}</nb-option
    >
  </nb-select> -->
</div>

<div class="header-container">
  <nb-actions size="small">
    <!-- <nb-action class="control-item">
      <nb-search type="rotate-layout"></nb-search>
    </nb-action> -->

    <nb-action (click)="feedback()" class="control-item">
      <nb-icon icon="bulb-outline"></nb-icon>
      <span class="label-login">Góp Ý / Báo lỗi</span>
    </nb-action>
  </nb-actions>
</div>

<div *ngIf="!(userService.$isAuthenticated | async)" class="header-container">
  <button
    nbButton
    outline
    status="primary"
    class="control-login-button"
    (click)="login()"
  >
    <nb-icon icon="power-outline"></nb-icon>
    <span class="label-login">Đăng nhập</span>
  </button>
</div>

<div *ngIf="userService.$isAuthenticated | async" class="header-container">
  <nb-actions size="medium">
    <!-- <nb-action class="control-item" icon="plus-outline"></nb-action> -->
    <nb-action
      [badgeText]="
        userData?.notifications < 100
          ? userData?.notifications <= 0
            ? '.'
            : userData?.notifications
          : '+99'
      "
      badgeStatus="danger"
      badgePosition="top right"
      icon="bell-outline"
      (click)="notifications()"
    ></nb-action>

    <nb-action class="user-action">
      <nb-user
        [nbContextMenu]="userMenu"
        [onlyPicture]="userPictureOnly"
        [name]="(userService.currentUser$ | async)?.displayName"
        [picture]="(userService.currentUser$ | async)?.photoURL"
      >
      </nb-user>
    </nb-action>
  </nb-actions>
</div>
